import React, { Component } from "react";
import { connect } from "react-redux";
import { func } from "prop-types";
import { actions as echeckActions } from "reducers/echecks";
import { Field, Form, withFormik } from "formik";
import { compose } from "redux";
import TextField from "pages/_components/fields/TextField";
import Button from "pages/_components/Button";
import * as Yup from "yup";
import * as i18n from "util/i18n";
import I18n from "pages/_components/I18n";
import { push } from "connected-react-router";

const FORM_ID = "echeqs";

class RepudiateEcheq extends Component {
    static propTypes = {
        handleSubmit: func.isRequired,
    };

    render() {
        const { handleSubmit } = this.props;
        return (
            <div className="container">
                <I18n id="echeck.repudiate.reason" component="h2" />
                <Form
                    className="above-the-fold"
                    onSubmit={(e) => {
                        handleSubmit(e);
                        e.stopPropagation();
                    }}>
                    <Field
                        component={TextField}
                        name="motive"
                        type="text"
                        hidePlaceholder
                        idForm={FORM_ID}
                        labelText="echeck.repudiate.label"
                        maxLength="500"
                    />
                    <Button type="submit" className="btn-primary" label="global.add" />
                </Form>
            </div>
        );
    }
}

export default compose(
    connect(),
    withFormik({
        mapPropsToValues: () => ({ motive: "" }),
        validationSchema: () =>
            Yup.object().shape({
                motive: Yup.string().required(i18n.get("global.error.required")),
            }),
        handleSubmit: (filters, formikBag) => {
            const { dispatch } = formikBag.props;

            dispatch(echeckActions.setEcheqsSpecialAttribute(filters.motive));
            dispatch(push("/echecks/action/transaction/confirm"));
        },
    }),
)(RepudiateEcheq);
